export const STATUSES_COLORS = {
  invited: "#B8A0ED",
  registered: "#8EE8AD",
  expired: "#EFC25E",
};

export const StatusBall = ({
  status,
}: {
  status: keyof typeof STATUSES_COLORS;
}) => {
  return (
    <div
      style={{
        width: "10px",
        height: "10px",
        background: STATUSES_COLORS[status] || "transparent",
        borderRadius: "100%",
        marginRight: "5px",
      }}
    />
  );
};
